// Import core lib dependencies.
import React 		from 'react';
import PropTypes from 'prop-types';

// Component dependencies.
import { Button } 	from '../../../../common/components/buttons.jsx';

/**
 * Namespace for Goal element components.
 *
 * @memberof module:Goal.Components
 * @namespace Elements
 */

/**
 * <pre>
 * Goal -> ParticipateButton module React class.
 *
 * This component outputs markup to render a ParticipateButton within the Goal component.
 * </pre>
 *
 * @author Tim Loram
 *
 * @docPreview {namedExport: "docPreviewExport"}
 *
 * @memberof module:Goal.Components.Elements
 * @namespace
 *
 * @return {module:Goal.Components.Elements.ParticipateButton}
 */
class ParticipateButton extends React.Component {

  /**
     * Constructor.
     *
     * @param {object} props The injected props
     */
  constructor(props) {

    super(props);

    // Bind methods.
    this.handleParticipateClicked = this.handleParticipateClicked.bind(this);
  }

  /**
     * Render
     *
     * @return {module:Goal.Components.Elements.ParticipateButton}
     */
  render() {

    // Decide which label to use based on user participation state.
    const label = (!this.props.alreadyParticipated) ? this.props.labels.participate : this.props.labels.alreadyParticipated;

    // And which class to append.
    let _buttonWrapperClasses = 'xParticipateWrapper xButtonWrapper';
    _buttonWrapperClasses += (this.props.alreadyParticipated) ? ' xAlreadyParticipated' : '';

    let _buttonClasses = 'xButton xParticipate';
    _buttonClasses += (this.props.alreadyParticipated) ? ' xDisabled' : '';

    return (

      <div className={_buttonWrapperClasses}>

        <Button onClick={this.handleParticipateClicked} className={_buttonClasses}>
          {label}
        </Button>

      </div>
    );
  }

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Event handler methods */

  /**
	 * Handler called when participate button is clicked.
	 *
	 */
  handleParticipateClicked(event) {

    // If we have not already participated, call our handler.
    if (!this.props.alreadyParticipated) {

      this.props.handler();

      // Otherwise...
    } else {

      // Do nothing.
    }
  }
}

/**
 * React PropTypes.
 *
 * @type {Object}
 * @property {Function} handler The handler function to call when button is clicked.
 * @property {Boolean} alreadyParticipated Boolean indicating if the user has already participated for the current Goal/Milestone.
 * @property {Object} labels Object defining a k/v set of localized labels.
 */
ParticipateButton.propTypes = {
  handler:  				       PropTypes.func,
  alreadyParticipated: 	PropTypes.bool,
  labels: 				         PropTypes.object
};

/**
 * React default props.
 *
 * @type {Object}
 */
ParticipateButton.defaultProps = {
};

// Export the dumb component.
export default ParticipateButton;
